import { render, staticRenderFns } from "./ItemFailuresModal.vue?vue&type=template&id=d35242d8&scoped=true"
import script from "./ItemFailuresModal.vue?vue&type=script&lang=ts"
export * from "./ItemFailuresModal.vue?vue&type=script&lang=ts"
import style0 from "./ItemFailuresModal.vue?vue&type=style&index=0&id=d35242d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35242d8",
  null
  
)

export default component.exports